<div #chartContainer class="google-barchart-container"></div>
